module.exports = "/_next/static/images/jennifer-sands@2x-0dc11f5591899df014a840b19c1c1369.png";